module.exports = __webpack_public_path__ + "media/images/swifticons/paper-airplane-icon-347c30caa15400a673a7a9a3852423ae.svg";